// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + "desktop" + "_" + "7f9c1f9bddb53d02c522" + ".css";
};